import React, { Component } from "react";

import Input from "../../components/inputs/input";
import ConsultarSearchButton from "./consultar-searchbutton";
import ResultCard from "./result-card";

import AppContext from "../../appContext";
import Swal from "sweetalert2";
import TabelaPares from "./consultar-tabela-pares";

import Prism from "prismjs";
import "prismjs/components/prism-json";
import "prismjs/themes/prism.css";
import { CopyToClipboard } from "react-copy-to-clipboard";

class ConsultarCupom extends Component {
  constructor() {
    super();

    this.state = {
      cupom_promocional: "",
      voucher_data: "",
      voucher_data_raw: null,
      show_json_modal: false,
      json_copied: false,
    };

    ConsultarCupom.contextType = AppContext;

    this.handleChange = this.handleChange.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
    this.searchVoucher = this.searchVoucher.bind(this);
  }

  handleKeyDown(event) {
    if (event.key === "Enter" && this.state.cupom_promocional) {
      this.searchVoucher();
    }
  }

  handleChange(event) {
    let state = {};
    const name = event.target.getAttribute("name");
    const { value } = event.target;

    if (value !== state[name]) {
      state[name] = value ? value : "";
      this.setState(state);
    }
  }

  searchVoucher() {
    this.context.showLoading("Carregando...");

    const requestOptions = {
      method: "GET",
      headers: {
        access_token: sessionStorage.getItem("token"),
        client_id: localStorage.getItem("clientid"),
      },
    };

    const voucherId = this.state.cupom_promocional;

    this.setState({
      voucher_data: "",
      voucher_data_raw: null,
    });

    fetch(process.env.REACT_APP_ESSILOR_API + `gestao-pedidos-laboratorio/v1/vouchers/${voucherId}`, requestOptions)
      .then(response => {
        this.context.hideLoading();

        return response.json();
      })
      .then(json => {
        if (json[0] && json[0]?.codigo !== 200) {
          Swal.fire({
            text: json[0]?.mensagem,
            icon: "error",
            title: "Ocorreu um erro na solicitação",
            confirmButtonColor: "#00518b",
            customClass: {
              confirmButton: "x-follow-order__filter-btn",
            },
          });
        } else {
          this.setState({
            voucher_data: json,
            voucher_data_raw: json,
          });
        }
      });
  }

  render() {
    const { show_json_modal, voucher_data_raw, json_copied } = this.state;

    const highlighted = voucher_data_raw
      ? Prism.highlight(JSON.stringify(voucher_data_raw, null, 2), Prism.languages.json, "json")
      : "";

    return (
      <div className="consultar-cupom__container">
        <div id="main-tabela">
          <div className="title-container">
            <h1 className="main-title">Consultar Cupom</h1>
            <span className="title-shape"></span>
          </div>

          <div className="consultar-form-row">
            <div className="consultar-form-input">
              <Input
                name="cupom_promocional"
                id="cupom-promocional"
                type="text"
                label="Cupom Promocional"
                aria="Cupom Promocional"
                value={this.state.cupom_promocional}
                onChange={this.handleChange}
                onKeyDown={this.handleKeyDown}
                tooltip=""
              />
            </div>
            <ConsultarSearchButton onClick={this.searchVoucher} />
          </div>

          {this.state.voucher_data && <ResultCard data={this.state.voucher_data} />}
          {this.state.voucher_data && <TabelaPares lab={this.state.voucher_data.laboratorio} data={this.state.voucher_data} onRefresh={this.searchVoucher} />}

          {this.state.voucher_data && (
            <div className="mais-informacoes-container">
              <a
                href="#mais-informacoes"
                className="mais-informacoes-link"
                onClick={e => {
                  e.preventDefault();
                  this.setState({ show_json_modal: true });
                }}
              >
                Mais informações
              </a>
            </div>
          )}

          {show_json_modal && (
            <div
              className="json-modal-overlay"
              onClick={() => this.setState({ show_json_modal: false })}
            >
              <div
                className="json-modal-content"
                onClick={e => e.stopPropagation()}
              >
                <div className="json-modal-header">
                  <CopyToClipboard
                    text={JSON.stringify(voucher_data_raw, null, 2)}
                    onCopy={() => {
                      this.setState({ json_copied: true });
                      setTimeout(() => this.setState({ json_copied: false }), 2000);
                    }}
                  >
                    <button className="json-modal-copy-btn">
                      {json_copied ? "Copiado!" : "Copiar JSON"}
                    </button>
                  </CopyToClipboard>
                  <button
                    className="json-modal-close"
                    onClick={() => this.setState({ show_json_modal: false })}
                  >
                    ✕
                  </button>
                </div>
                <div className="json-modal-body">
                  <pre className="json-modal-pre">
                    <code dangerouslySetInnerHTML={{ __html: highlighted }} />
                  </pre>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default ConsultarCupom;
